// extracted by mini-css-extract-plugin
module.exports = {"input":"CheckboxField_input__5t4Aq","checkbox":"CheckboxField_checkbox__H5M3G","focus-visible":"CheckboxField_focus-visible__80_VC"};